/**
 * @fileoverview Hook Actions Layer para cambio de estado de orden de cliente en Inbox.
 * @module useCustomerOrderStatusActions
 * @category Hook - Actions Layer
 * @since 1.0.0
 * @version 2.0.0
 */
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { LOAD_DATA_FAILURE } from "../../../../actions/inbox/conversationActions";
import orderShopModelMC from '../../../models/OrderShopModelMC';

/**
 * Hook Actions Layer para cambio de estado de orden de cliente.
 * Separa lógica de negocio y maneja loading y errores.
 *
 * @function useCustomerOrderStatusActions
 * @param {Object} params
 * @param {Object} params.order - Objeto de orden
 * @param {Function} params.updateOrderInList - Callback para actualizar orden en lista
 * @returns {Object} { updateOrderStatus, loading }
 */
export default function useCustomerOrderStatusActions({ order, updateOrderInList }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  /**
   * Actualiza el estado de la orden en backend y lista local.
   * @async
   * @param {string} newStatus - Nuevo estado a aplicar
   * @returns {Promise<void>}
   */
  const updateOrderStatus = useCallback(async (newStatus) => {
    setLoading(true);
    try {
      const response = await orderShopModelMC.save({ id: order.web_id, status: newStatus });
      updateOrderInList(response.order);
    } catch (error) {
      dispatch({ type: LOAD_DATA_FAILURE, error: error.message || 'Error updating customer order.' });
    } finally {
      setLoading(false);
    }
  }, [dispatch, order?.web_id, updateOrderInList]);

  return { updateOrderStatus, loading };
}
